import React from 'react';
export function Divider({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <div className={`w-full flex justify-center items-center py-8 ${className}`} style={style} data-id="element-45">
      <svg width="200" height="20" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-sage-deep opacity-40" data-id="element-46">
        <path d="M10 10Q50 0 100 10T190 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4" data-id="element-47" />
        <circle cx="100" cy="10" r="3" fill="currentColor" data-id="element-48" />
        <path d="M90 10C90 5 95 5 100 10C105 15 110 15 110 10" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-49" />
      </svg>
    </div>;
}